import moment from "moment-timezone";
import _ from "lodash";

export function expiresIn1MonthFromNow(exp: string | undefined) {
  if (typeof exp === "undefined") {
    return false;
  }
  const oneMonthFromNow = moment().add(1, "month");
  const expirationDate = moment(exp);
  return expirationDate.isBefore(oneMonthFromNow) && expirationDate.isAfter(moment());
}

export const isExpired = (exp: string | undefined) => !exp || moment().isAfter(exp);

export const withinLast29Days = (date: string | undefined) => {
  if (!date) {
    return undefined;
  }
  const now = moment();
  const theDate = moment(date);
  const thirtyDaysAgo = moment().subtract(30, "days");
  return theDate.isAfter(thirtyDaysAgo) && theDate.isBefore(now);
};

export const moreThan29DaysAgo = (date: string | undefined) => {
  if (!date) {
    return undefined;
  }
  const theDate = moment(date);
  const thirtyDaysAgo = moment().subtract(30, "days");
  return theDate.isSameOrBefore(thirtyDaysAgo);
};

/**
 * FIXME - verify that this code is always being called with a number, and then clean this up.
 */
export function convertToHHMM(fraction: number) {
  /**
   * FIXME Refactor this code
   @ts-expect-error Argument of type 'number' is not assignable to parameter of type 'string'.ts(2345) */
  const hrs = parseInt(Number(fraction));
  const mins = Math.round((Number(fraction) - hrs) * 60); // Do we round up or down the time? Does not affect the pay calculation.

  /**
   * FIXME Refactor this code
   @ts-expect-error Argument of type 'number' is not assignable to parameter of type 'string'.ts(2345) */
  return `${_.padStart(hrs, 2, 0)}:${_.padStart(mins, 2, 0)}`;
}

export interface MonthOfYear {
  sequence: number;
  name: string;
}
export const JAN = { sequence: 1, name: "January" };
export const FEB = { sequence: 2, name: "February" };
export const MAR = { sequence: 3, name: "March" };
export const APR = { sequence: 4, name: "April" };
export const MAY = { sequence: 5, name: "May" };
export const JUN = { sequence: 6, name: "June" };
export const JUL = { sequence: 7, name: "July" };
export const AUG = { sequence: 8, name: "August" };
export const SEP = { sequence: 9, name: "September" };
export const OCT = { sequence: 10, name: "October" };
export const NOV = { sequence: 11, name: "November" };
export const DEC = { sequence: 12, name: "December" };
// Date objects starts counting month beginning with index 0
const monthByIndex = new Map([
  [0, JAN],
  [1, FEB],
  [2, MAR],
  [3, APR],
  [4, MAY],
  [5, JUN],
  [6, JUL],
  [7, AUG],
  [8, SEP],
  [9, OCT],
  [10, NOV],
  [11, DEC],
]);
export function getMonthByIndex(index: number) {
  return monthByIndex.get(index);
}
